module.exports = __webpack_public_path__ + "claudio.png?82684738c21fd493f29af33a8fabcd3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/claudio.png
// module id = 42
// module chunks = 0